import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const equipmentSubCategoryTypesAdapter = getAdapter();

const equipmentSubCategoryTypesSlice = createSlice({
  name: 'equipmentSubCategoryTypes',
  initialState: equipmentSubCategoryTypesAdapter.getInitialState(),
  reducers: {
    setEquipmentSubCategoryTypes: (state, { payload: { equipmentSubCategoryTypes } }) => {
      equipmentSubCategoryTypesAdapter.setAll(state, equipmentSubCategoryTypes);
    },
  },
});

const selectors = equipmentSubCategoryTypesAdapter.getSelectors(({ equipmentSubCategoryTypes }) => equipmentSubCategoryTypes);

export const getEquipmentSubCategoryTypes = (state) => selectors.selectAll(state);

export const {
  setEquipmentSubCategoryTypes,
} = equipmentSubCategoryTypesSlice.actions;

export default equipmentSubCategoryTypesSlice.reducer;
